/* ============================================================
   QI PREMIUM GIFT CARD OPTIONS
   ============================================================ */

(function () {

  'use strict';


  /* ==========================================================
     INITIALISATION
     ========================================================== */

  function initAll(scope) {

    const context =
      scope || document;

    context
      .querySelectorAll(
        '[data-qi-gift-options]'
      )
      .forEach(
        initQiGiftOptions
      );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAll(document);
      }
    );

  } else {

    initAll(document);

  }


  /*
   * Reinitialise if Shopify Theme Editor reloads section.
   */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      initAll(event.target);

    }
  );


  /* ==========================================================
     MAIN COMPONENT
     ========================================================== */

  function initQiGiftOptions(root) {

    /*
     * Prevent duplicate event listeners.
     */

    if (
      root.dataset.qiInitialised === 'true'
    ) {
      return;
    }

    root.dataset.qiInitialised =
      'true';


    const sectionId =
      root.dataset.sectionId;


    /*
     * Locate surrounding Shopify section.
     */

    const section =

      root.closest('.shopify-section') ||

      root.closest('section') ||

      document;


    /*
     * Locate Dawn / Dawn-style product form.
     */

    const productFormElement =

      section.querySelector(
        `product-form[data-section-id="${sectionId}"]`
      ) ||

      section.querySelector(
        'product-form'
      );


    const productForm =

      productFormElement

        ? productFormElement.querySelector(
            'form[action*="/cart/add"]'
          )

        : section.querySelector(
            'form[action*="/cart/add"]'
          );


    if (!productForm) {

      console.warn(
        'Qi Gift Options: product form could not be found.'
      );

      return;

    }


    const addonVariantId =
      Number(
        root.dataset.addonVariantId
      );


    if (!addonVariantId) {

      console.warn(
        'Qi Gift Options: physical add-on variant ID is missing.'
      );

      return;

    }


    /* ========================================================
       ELEMENTS
       ======================================================== */

    const formatInputs =

      root.querySelectorAll(
        '[data-qi-format]'
      );


    const physicalFields =

      root.querySelector(
        '[data-physical-fields]'
      );


    const openToggle =

      root.querySelector(
        '[data-open-date-toggle]'
      );


    const openWrapper =

      root.querySelector(
        '[data-open-date-wrapper]'
      );


    const openDateInput =

      root.querySelector(
        '[data-qi-open-date]'
      );


    const giftPreviewOpen =

      root.querySelector(
        '[data-gift-preview-open]'
      );


    const giftPreviewModal =

      root.querySelector(
        '[data-gift-preview-modal]'
      );


    const giftPreviewCloseButtons =

      root.querySelectorAll(
        '[data-gift-preview-close]'
      );


    const giftPreviewImage =

      root.querySelector(
        '[data-gift-preview-image]'
      );


    const messageInput =

      root.querySelector(
        '[data-qi-property="Gift message"]'
      );


    const messageCount =

      root.querySelector(
        '[data-message-count]'
      );


    const submitButton =

      productForm.querySelector(
        '[name="add"]'
      ) ||

      productForm.querySelector(
        '[type="submit"]'
      );


    const physicalSubmitButton =

      root.querySelector(
        '[data-qi-physical-submit]'
      );


    const physicalSubmitButtonText =

      root.querySelector(
        '[data-qi-physical-submit-text]'
      );



    const dynamicCheckout =

      productForm.querySelector(
        '.shopify-payment-button'
      );


    const submitButtonText =

      submitButton

        ? (
            submitButton.querySelector('span') ||
            submitButton
          )

        : null;


    /*
     * Shopify native gift recipient form.
     */

    const recipientForm =

      productForm.querySelector(
        'recipient-form.recipient-form'
      ) ||

      productForm.querySelector(
        '.recipient-form'
      );


    /* ========================================================
       RELABEL SHOPIFY EGIFT CHECKBOX
       ======================================================== */

    customiseRecipientForm(
      recipientForm
    );


    /* ========================================================
       CURRENT FORMAT
       ======================================================== */

    function selectedFormat() {

      const selected =

        root.querySelector(
          '[data-qi-format]:checked'
        );


      return selected

        ? selected.value

        : 'egift';

    }

    /* ========================================================
       UPDATE UI
       ======================================================== */

    function updateFormatUI() {

      const format =
        selectedFormat();


      const isPhysical =
        format === 'physical';


      /*
       * Format card appearance.
       */

      root
        .querySelectorAll(
          '.qi-gift-format-card'
        )
        .forEach(
          function (card) {

            const radio =

              card.querySelector(
                '[data-qi-format]'
              );


            card.classList.toggle(
              'is-selected',
              Boolean(
                radio &&
                radio.checked
              )
            );

          }
        );


      /*
       * Physical fields.
       */

      if (physicalFields) {

        physicalFields.hidden =
          !isPhysical;

      }


      /*
       * Native Shopify eGift recipient form.
       *
       * eGift:
       * visible.
       *
       * Physical:
       * hidden.
       */

      if (recipientForm) {

        recipientForm.hidden =
          isPhysical;

      }


      /*
       * CTA behaviour:
       *
       * eGift:
       * keep Shopify's original product CTA.
       *
       * Physical:
       * hide Shopify's original CTA and use our dedicated
       * two-line-item add-to-basket button instead.
       */

      if (submitButton) {

        submitButton.hidden =
          isPhysical;

      }


      if (physicalSubmitButton) {

        physicalSubmitButton.hidden =
          !isPhysical;

      }


      if (dynamicCheckout) {

        dynamicCheckout.hidden =
          isPhysical;

      }


      if (productFormElement) {

        productFormElement.classList.toggle(
          'qi-physical-selected',
          isPhysical
        );

        productFormElement.classList.toggle(
          'qi-egift-selected',
          !isPhysical
        );

      }


      updateSubmitButton();

    }


    /* ========================================================
       BUTTON TEXT
       ======================================================== */

    function updateSubmitButton() {

      if (
        !submitButton ||
        selectedFormat() !== 'egift'
      ) {
        return;
      }


      const textTarget =

        submitButton.querySelector(
          'span'
        ) ||

        submitButton.querySelector(
          '.button__text'
        ) ||

        submitButton;


      if (textTarget) {

        textTarget.textContent =
          'Buy Voucher';

      }


      if (
        submitButton.tagName ===
        'INPUT'
      ) {

        submitButton.value =
          'Buy Voucher';

      }


      submitButton.setAttribute(
        'aria-label',
        'Buy Voucher'
      );

    }


    /* ========================================================
       FORMAT CHANGE
       ======================================================== */

    formatInputs.forEach(
      function (input) {

        input.addEventListener(
          'change',
          updateFormatUI
        );

      }
    );



    /*
     * Re-apply the eGift CTA wording after Shopify variant changes.
     * A short timeout avoids interfering with the theme's own update cycle.
     */

    section.addEventListener(
      'change',
      function (event) {

        const target =
          event.target;


        if (
          !target ||
          selectedFormat() !== 'egift'
        ) {
          return;
        }


        if (
          target.matches(
            'select[name="id"], input[name="id"], input[type="radio"]'
          )
        ) {

          window.setTimeout(
            updateSubmitButton,
            60
          );

        }

      }
    );


    /* ========================================================
       GIFT PRESENTATION PREVIEW
       ======================================================== */

    if (
      giftPreviewOpen &&
      giftPreviewModal
    ) {

      let lastFocusedElement =
        null;


      let previewPreloadStarted =
        false;


      /*
       * Move the modal to <body>.
       * This prevents sticky headers/navs with their own stacking
       * contexts from ever appearing above the lightbox.
       */

      if (
        giftPreviewModal.parentNode !==
        document.body
      ) {

        document.body.appendChild(
          giftPreviewModal
        );

      }


      function preloadGiftPreview() {

        if (
          previewPreloadStarted ||
          !giftPreviewImage
        ) {
          return;
        }


        const previewSrc =
          giftPreviewImage.dataset.giftPreviewSrc;


        if (!previewSrc) {
          return;
        }


        previewPreloadStarted =
          true;


        const preloader =
          new Image();


        preloader.decoding =
          'async';


        preloader.src =
          previewSrc;


        /*
         * decode() warms the decoded image where supported,
         * so opening the modal doesn't wait on decoding.
         */

        if (
          typeof preloader.decode ===
          'function'
        ) {

          preloader
            .decode()
            .catch(
              function () {}
            );

        }


        preloader.addEventListener(
          'load',
          function () {

            giftPreviewImage.src =
              previewSrc;

            giftPreviewImage.hidden =
              false;

            giftPreviewImage.dataset.qiLoaded =
              'true';

          },
          {
            once: true
          }
        );

      }


      /*
       * Start preloading only after the main page has finished loading,
       * so the preview does not compete with critical product assets.
       * requestIdleCallback is used when available.
       */

      function scheduleGiftPreviewPreload() {

        if (
          'requestIdleCallback' in window
        ) {

          window.requestIdleCallback(
            preloadGiftPreview,
            {
              timeout: 1200
            }
          );

        } else {

          window.setTimeout(
            preloadGiftPreview,
            350
          );

        }

      }


      if (
        document.readyState ===
        'complete'
      ) {

        scheduleGiftPreviewPreload();

      } else {

        window.addEventListener(
          'load',
          scheduleGiftPreviewPreload,
          {
            once: true
          }
        );

      }


      function openGiftPreview(event) {

        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }


        lastFocusedElement =
          document.activeElement;


        /*
         * Open the modal immediately.
         * The preview image itself is deliberately NOT loaded
         * until after the modal has painted.
         */

        giftPreviewModal.hidden =
          false;


        document.body.classList.add(
          'qi-gift-preview-open'
        );


        const closeButton =

          giftPreviewModal.querySelector(
            '.qi-gift-preview-modal__close'
          );


        if (closeButton) {
          closeButton.focus();
        }


        /*
         * In the normal case the image is already cached and decoded
         * by the background preload above. If the customer clicks
         * extremely quickly, start the same preload immediately.
         */

        if (
          giftPreviewImage &&
          !giftPreviewImage.dataset.qiLoaded
        ) {

          preloadGiftPreview();

        }

      }


      function closeGiftPreview(event) {

        if (event) {
          event.preventDefault();
          event.stopPropagation();
        }


        if (giftPreviewModal.hidden) {
          return;
        }


        giftPreviewModal.hidden =
          true;


        document.body.classList.remove(
          'qi-gift-preview-open'
        );


        if (
          lastFocusedElement &&
          typeof lastFocusedElement.focus ===
            'function'
        ) {

          lastFocusedElement.focus();

        }

      }


      giftPreviewOpen.addEventListener(
        'click',
        openGiftPreview
      );


      giftPreviewCloseButtons.forEach(
        function (button) {

          button.addEventListener(
            'click',
            closeGiftPreview
          );

        }
      );


      document.addEventListener(
        'keydown',
        function (event) {

          if (
            event.key === 'Escape' &&
            !giftPreviewModal.hidden
          ) {

            closeGiftPreview(event);

          }

        }
      );

    }


    /* ========================================================
       MESSAGE CHARACTER COUNTER
       ======================================================== */

    if (
      messageInput &&
      messageCount
    ) {

      function updateMessageCounter() {

        messageCount.textContent =
          String(
            messageInput.value.length
          );

      }


      messageInput.addEventListener(
        'input',
        updateMessageCounter
      );


      updateMessageCounter();

    }


    /* ========================================================
       OPEN DATE MINIMUM
       ======================================================== */

    const today =
      localISODate(
        new Date()
      );


    if (openDateInput) {

      openDateInput.min =
        today;

    }


    /* ========================================================
       OPEN ON DATE TOGGLE
       ======================================================== */

    if (
      openToggle &&
      openWrapper
    ) {

      openToggle.addEventListener(
        'change',
        function () {

          const enabled =
            openToggle.checked;


          openWrapper.hidden =
            !enabled;


          if (
            !enabled &&
            openDateInput
          ) {

            openDateInput.value =
              '';


            openDateInput.setCustomValidity(
              ''
            );

          }

        }
      );

    }


    /* ========================================================
       CLEAR REQUIRED FIELD ERRORS
       ======================================================== */

    root
      .querySelectorAll(
        '[data-physical-required]'
      )
      .forEach(
        function (field) {

          field.addEventListener(
            'input',
            function () {

              field.setCustomValidity(
                ''
              );

            }
          );

        }
      );


    /* ========================================================
       CLEAR DATE ERROR
       ======================================================== */

    if (openDateInput) {

      openDateInput.addEventListener(
        'change',
        function () {

          openDateInput.setCustomValidity(
            ''
          );

        }
      );

    }


    /* ========================================================
       INTERCEPT PHYSICAL ADD-TO-CART ONLY
       ======================================================== */

    /*
     * eGift:
     *
     * Shopify's normal product form handles everything.
     *
     * Physical:
     *
     * We intercept and add:
     *
     * 1. Voucher
     * 2. £4.99 physical presentation product
     */

    async function submitPhysicalGift(
      loadingButton
    ) {

      if (
        !validatePhysicalGift(
          root,
          openToggle,
          openDateInput
        )
      ) {

        return;

      }


      setLoadingState(
        loadingButton || submitButton,
        true
      );


      try {

        await addPhysicalGiftToCart(
          root,
          productForm,
          addonVariantId
        );


        await openCartDrawer();


        setLoadingState(
          loadingButton || submitButton,
          false
        );

      } catch (error) {

        console.error(
          'Qi Gift Options:',
          error
        );


        showError(
          productForm,

          error.message ||

          'Sorry, we could not add the gift card. Please try again.'
        );


        setLoadingState(
          loadingButton || submitButton,
          false
        );

      }

    }


    if (physicalSubmitButton) {

      physicalSubmitButton.addEventListener(
        'click',

        async function (event) {

          event.preventDefault();

          event.stopPropagation();


          if (
            selectedFormat() !==
            'physical'
          ) {

            return;

          }


          await submitPhysicalGift(
            physicalSubmitButton
          );

        }
      );

    }


    productForm.addEventListener(
      'submit',

      async function (event) {

        if (
          selectedFormat() !==
          'physical'
        ) {

          /*
           * EGIFT:
           *
           * Leave Shopify's normal
           * gift voucher process alone.
           */

          return;

        }


        /*
         * PHYSICAL:
         *
         * The original Shopify CTA is hidden for this mode.
         * Block any accidental native submit and let the dedicated
         * physical gift button handle the two-line-item add.
         */

        event.preventDefault();

        event.stopImmediatePropagation();

        return;

      },

      /*
       * Capture phase is intentional.
       * Dawn also listens for product form submit events.
       */

      true
    );

    /* ========================================================
       INITIAL STATE
       ======================================================== */

    updateFormatUI();

  }


  /* ==========================================================
     SHOPIFY EGIFT RECIPIENT FORM
     ========================================================== */

  function customiseRecipientForm(
    recipientForm
  ) {

    if (!recipientForm) {
      return;
    }


    /*
     * Change Shopify's native checkbox wording.
     */

    const checkboxLabelText =

      recipientForm.querySelector(
        'label.recipient-checkbox > span:last-child'
      );


    if (checkboxLabelText) {

      checkboxLabelText.textContent =
        'Send this eGift directly to the recipient';

    }

  }


  /* ==========================================================
     PHYSICAL VALIDATION
     ========================================================== */

  function validatePhysicalGift(
    root,
    openToggle,
    openDateInput
  ) {

    const requiredFields =

      root.querySelectorAll(
        '[data-physical-required]'
      );


    /*
     * TO / FROM REQUIRED
     */

    for (
      const field
      of requiredFields
    ) {

      field.setCustomValidity(
        ''
      );


      if (
        !field.value.trim()
      ) {

        field.setCustomValidity(
          'Please complete this field.'
        );


        field.reportValidity();


        field.focus();


        return false;

      }

    }


    /*
     * OPEN ON DATE
     *
     * Optional overall.
     *
     * If checkbox is selected,
     * date becomes required.
     */

    if (
      openToggle &&
      openToggle.checked &&
      openDateInput &&
      !openDateInput.value
    ) {

      openDateInput.setCustomValidity(
        'Please select the date this gift should be opened.'
      );


      openDateInput.reportValidity();


      openDateInput.focus();


      return false;

    }


    if (openDateInput) {

      openDateInput.setCustomValidity(
        ''
      );

    }


    return true;

  }


  /* ==========================================================
     ADD PHYSICAL GIFT
     ========================================================== */

  async function addPhysicalGiftToCart(
    root,
    productForm,
    addonVariantId
  ) {

    const voucherVariantInput =

      productForm.querySelector(
        '[name="id"]'
      );


    if (!voucherVariantInput) {

      throw new Error(
        'Voucher variant could not be found.'
      );

    }


    const voucherVariantId =

      Number(
        voucherVariantInput.value
      );


    if (!voucherVariantId) {

      throw new Error(
        'Please select a valid voucher option.'
      );

    }


    /*
     * Quantity
     */

    const quantityInput =

      productForm.querySelector(
        '[name="quantity"]'
      );


    const quantity =

      quantityInput

        ? Math.max(
            1,
            parseInt(
              quantityInput.value,
              10
            ) || 1
          )

        : 1;


    /*
     * Unique reference linking voucher
     * and physical presentation line.
     */

    const giftUid =
      generateGiftUid();


    /* ========================================================
       VOUCHER PROPERTIES
       ======================================================== */

    const voucherProperties = {

      'Delivery format':
        'Premium Physical Gift Card',


      'To':
        getPropertyValue(
          root,
          'To'
        ),


      'From':
        getPropertyValue(
          root,
          'From'
        ),


      '_Qi Gift UID':
        giftUid

    };


    const messageInput =

      root.querySelector(
        '[data-qi-property="Gift message"]'
      );


    const message =

      messageInput

        ? String(
            messageInput.value || ''
          ).trim()

        : '';


    const openDate =

      getPropertyValue(
        root,
        'Open on date'
      );


    /*
     * Only include optional properties
     * when populated.
     */

    if (message) {

      voucherProperties[
        'Gift message'
      ] = message;

    }


    if (openDate) {

      voucherProperties[
        'Open on date'
      ] = openDate;

    }


    /* ========================================================
       ADD-ON PROPERTIES
       ======================================================== */

    const addonProperties = {

      '_Qi Gift UID':
        giftUid,


      '_Linked voucher':
        root.dataset.productTitle || '',


      '_Voucher variant ID':
        String(
          voucherVariantId
        )

    };


    /* ========================================================
       AJAX CART PAYLOAD
       ======================================================== */

    const payload = {

      items: [

        /*
         * Original voucher
         */

        {
          id:
            voucherVariantId,

          quantity:
            quantity,

          properties:
            voucherProperties
        },


        /*
         * £4.99 physical presentation
         */

        {
          id:
            addonVariantId,

          quantity:
            quantity,

          properties:
            addonProperties
        }

      ]

    };


    /* ========================================================
       SHOPIFY AJAX CART
       ======================================================== */

    const rootUrl =

      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root

        ? window.Shopify.routes.root

        : '/';


    const response =

      await fetch(
        rootUrl + 'cart/add.js',
        {

          method:
            'POST',


          headers: {

            'Content-Type':
              'application/json',

            'Accept':
              'application/json',

            'X-Requested-With':
              'XMLHttpRequest'

          },


          body:
            JSON.stringify(
              payload
            )

        }
      );


    let responseBody =
      null;


    try {

      responseBody =
        await response.json();

    } catch (error) {

      responseBody =
        null;

    }


    if (!response.ok) {

      throw new Error(

        (
          responseBody &&
          (
            responseBody.description ||
            responseBody.message
          )
        ) ||

        'Unable to add the gift card to your basket.'

      );

    }


    return responseBody;

  }


  /* ==========================================================
     CART DRAWER
     ========================================================== */

  async function openCartDrawer() {

    const rootUrl =

      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root

        ? window.Shopify.routes.root

        : '/';


    /*
     * Fetch completely fresh Shopify-rendered cart sections.
     *
     * A timestamp prevents theme/CDN/browser caching from returning
     * the pre-add empty drawer.
     */

    const cacheBuster =
      Date.now();


    const sectionUrl =

      rootUrl +
      '?sections=cart-drawer,cart-icon-bubble' +
      '&_qi=' +
      cacheBuster;


    const response =

      await fetch(
        sectionUrl,
        {
          method:
            'GET',

          headers: {

            'Accept':
              'application/json',

            'X-Requested-With':
              'XMLHttpRequest'

          },

          cache:
            'no-store'

        }
      );


    if (!response.ok) {

      throw new Error(
        'The basket was updated, but the basket drawer could not be refreshed.'
      );

    }


    const sectionsResponse =

      await response.json();


    const parser =
      new DOMParser();


    /* ========================================================
       REPLACE THE ENTIRE CART DRAWER ELEMENT
       ======================================================== */

    if (
      sectionsResponse &&
      sectionsResponse['cart-drawer']
    ) {

      const drawerDocument =

        parser.parseFromString(
          sectionsResponse['cart-drawer'],
          'text/html'
        );


      const newDrawer =

        drawerDocument.querySelector(
          'cart-drawer'
        );


      const currentDrawer =

        document.querySelector(
          'cart-drawer'
        );


      if (
        newDrawer &&
        currentDrawer
      ) {

        /*
         * This is intentionally replaceWith(), not innerHTML.
         *
         * Dawn stores important state such as "is-empty" on the
         * <cart-drawer> element itself. Replacing only innerHTML
         * leaves the old empty-state class behind, which is why
         * the basket appeared empty until a full page refresh.
         */

        currentDrawer.replaceWith(
          newDrawer
        );

      }

    }


    /* ========================================================
       REPLACE THE ENTIRE CART ICON BUBBLE
       ======================================================== */

    if (
      sectionsResponse &&
      sectionsResponse['cart-icon-bubble']
    ) {

      const bubbleDocument =

        parser.parseFromString(
          sectionsResponse['cart-icon-bubble'],
          'text/html'
        );


      const newBubble =

        bubbleDocument.querySelector(
          '#cart-icon-bubble'
        );


      const currentBubble =

        document.querySelector(
          '#cart-icon-bubble'
        );


      if (
        newBubble &&
        currentBubble
      ) {

        currentBubble.replaceWith(
          newBubble
        );

      }

    }


    /*
     * Query again because the old drawer element has just
     * been replaced with Shopify's fresh element.
     */

    const refreshedDrawer =

      document.querySelector(
        'cart-drawer'
      );


    /*
     * Give the browser/custom-elements lifecycle one frame to
     * connect the replacement drawer before asking it to open.
     */

    await new Promise(
      function (resolve) {

        window.requestAnimationFrame(
          function () {

            window.requestAnimationFrame(
              resolve
            );

          }
        );

      }
    );


    if (
      refreshedDrawer &&
      typeof refreshedDrawer.open ===
        'function'
    ) {

      refreshedDrawer.open();

      return;

    }


    /*
     * Dawn fallback if the custom element has not exposed open()
     * for some reason. Mirror the normal drawer open classes.
     */

    if (refreshedDrawer) {

      refreshedDrawer.classList.remove(
        'is-empty'
      );


      refreshedDrawer.classList.add(
        'animate',
        'active'
      );


      document.body.classList.add(
        'overflow-hidden'
      );


      const drawerOverlay =

        refreshedDrawer.querySelector(
          '#CartDrawer-Overlay'
        );


      if (drawerOverlay) {

        drawerOverlay.setAttribute(
          'aria-hidden',
          'false'
        );

      }


      return;

    }


    /*
     * Last-resort compatibility event for non-Dawn custom drawers.
     */

    document.dispatchEvent(
      new CustomEvent(
        'cart:refresh',
        {
          bubbles:
            true,

          detail: {

            source:
              'qi-physical-gift'

          }

        }
      )
    );

  }


  /* ==========================================================
     PROPERTY VALUE
     ========================================================== */

  function getPropertyValue(
    root,
    propertyName
  ) {

    const element =

      root.querySelector(
        `[data-qi-property="${propertyName}"]`
      );


    if (!element) {

      return '';

    }


    return String(
      element.value || ''
    ).trim();

  }


  /* ==========================================================
     UNIQUE GIFT ID
     ========================================================== */

  function generateGiftUid() {

    if (
      window.crypto &&
      typeof window.crypto.randomUUID ===
      'function'
    ) {

      return (
        window.crypto.randomUUID()
      );

    }


    return (

      'qi-' +

      Date.now() +

      '-' +

      Math.random()
        .toString(36)
        .slice(2, 10)

    );

  }


  /* ==========================================================
     LOCAL DATE YYYY-MM-DD
     ========================================================== */

  function localISODate(date) {

    const year =
      date.getFullYear();


    const month =

      String(
        date.getMonth() + 1
      ).padStart(
        2,
        '0'
      );


    const day =

      String(
        date.getDate()
      ).padStart(
        2,
        '0'
      );


    return (

      year +
      '-' +
      month +
      '-' +
      day

    );

  }


  /* ==========================================================
     LOADING STATE
     ========================================================== */

  function setLoadingState(
    button,
    loading
  ) {

    if (!button) {
      return;
    }


    if (loading) {

      button.setAttribute(
        'aria-disabled',
        'true'
      );


      button.classList.add(
        'loading'
      );

    } else {

      button.removeAttribute(
        'aria-disabled'
      );


      button.classList.remove(
        'loading'
      );

    }

  }


  /* ==========================================================
     ERROR DISPLAY
     ========================================================== */

  function showError(
    productForm,
    message
  ) {

    const wrapper =

      productForm.querySelector(
        '.product-form__error-message-wrapper'
      );


    const text =

      wrapper

        ? wrapper.querySelector(
            '.product-form__error-message'
          )

        : null;


    if (
      wrapper &&
      text
    ) {

      text.textContent =
        message;


      wrapper.hidden =
        false;


      wrapper.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });

    } else {

      alert(
        message
      );

    }

  }


})();